import { render, staticRenderFns } from "./FileManagementImage.vue?vue&type=template&id=595d8a3a&scoped=true&"
import script from "./FileManagementImage.vue?vue&type=script&lang=js&"
export * from "./FileManagementImage.vue?vue&type=script&lang=js&"
import style0 from "./FileManagementImage.vue?vue&type=style&index=0&id=595d8a3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d8a3a",
  null
  
)

export default component.exports